import { Component, OnInit, Input} from '@angular/core';

// env
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-card-aspect',
  templateUrl: './card-aspect.component.html',
  styles: [
  ]
})
export class CardAspectComponent implements OnInit {

  @Input() dataAspect;
  apiAsset = environment.API_ASSETS;
  
  constructor() { }

  ngOnInit(): void {
  }

}
